import { Controller } from 'react-hook-form'
import UserFormField from '../../User/UserFormField'
import { useFormContextRequester } from '../utils/_utils'

const Rpps = () => {
    const { control } = useFormContextRequester()

    return (
        <Controller
            control={control}
            name="rppsNum"
            render={({ field, fieldState: { error } }) => (
                <UserFormField
                    variant="input"
                    label="Identifiant RPPS"
                    placeholder="Identifiant RPPS"
                    locked
                    disabled
                    status={{
                        error,
                        valid: (field.value?.trim().length ?? 0) > 0,
                    }}
                    {...field}
                    value={field?.value ?? ''}
                />
            )}
        />
    )
}

export default Rpps
